import { render, staticRenderFns } from "./CabinRate.vue?vue&type=template&id=b95a7644&scoped=true"
import script from "./CabinRate.vue?vue&type=script&lang=js"
export * from "./CabinRate.vue?vue&type=script&lang=js"
import style0 from "./CabinRate.vue?vue&type=style&index=0&id=b95a7644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95a7644",
  null
  
)

export default component.exports